/**
 * SkusProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'
import SkusContext from './skus-context'
import { fetchSkus } from './skus-api'
import { getAllDataInParallel } from '../../helpers'

export default function SkusProvider({ children }) {

  function fetchSkusAll(params) {
    return getAllDataInParallel({
      fn: (args) => fetchSkus({
        ...params,
        ...args,
      }),
      key: 'skus',
    })
  }

  const state = {
    fetchSkus,
    fetchSkusAll,
  }
  return (
    <SkusContext.Provider value={state}>
      {children}
    </SkusContext.Provider>
  )
}
